import { useCallback } from "react";
import _ from "lodash";

import SearchField from "components/SearchField";
import { useFilters } from "components/useFilters";

import { SEARCH_STRING_FILTER_KEY } from "entities/Reporting/constants";

const CustomerSearchField = () => {
  const { filters, updateFilter, deleteFilter } = useFilters();

  const handleSearch = useCallback(
    (e: any) => {
      const value = e.target.value;
      if (value !== "") {
        updateFilter({ key: SEARCH_STRING_FILTER_KEY, value });
      } else {
        deleteFilter({ key: SEARCH_STRING_FILTER_KEY });
      }
    },
    [updateFilter, deleteFilter]
  );

  return (
    <SearchField
      size="small"
      placeholder="Search by company name"
      defaultValue={filters[SEARCH_STRING_FILTER_KEY]}
      onChange={_.debounce(handleSearch, 200)}
      sx={{ backgroundColor: "white" }}
    />
  );
};

export default CustomerSearchField;
